import { render, staticRenderFns } from "./MetricsDetail.vue?vue&type=template&id=3ae11d36&scoped=true"
import script from "./MetricsDetail.vue?vue&type=script&lang=js"
export * from "./MetricsDetail.vue?vue&type=script&lang=js"
import style0 from "./MetricsDetail.vue?vue&type=style&index=0&id=3ae11d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae11d36",
  null
  
)

export default component.exports